import React from "react";

const styles = {
  title: {
    color: "#5D6965",
    fontFamily: "Outfit, sans-serif",
    fontSize: "20px",
    fontWeight: 400,
    textDecoration: "none",
    marginBottom: "20px",
  },
  subtitle: {
    color: "#5D6965",
    fontFamily: "Outfit, sans-serif",
    fontSize: "16px",
    fontWeight: 300,
    margin: "12px 0",
  },
};

const ApproveModal = (props) => {
  const { record } = props;

  return (
    <div>
      <div style={styles.title}>Company details</div>
      <div style={styles.subtitle}>Name: {record.name}</div>
      <div style={styles.subtitle}>Email: {record.email}</div>
      <div style={styles.subtitle}>
        Address: {record.city}, {record.streetName}, {record.houseNumber},{" "}
        {record.zipCode}
      </div>
    </div>
  );
};

export default ApproveModal;



// WEBPACK FOOTER //
// ./src/components/ApproveModal.js